import { FC } from "react";
import { Logo } from "../../primitives/Logo/Logo";

export const HeaderLogo: FC = () => (
  <div className="w-[168px] absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 pt-2">
    <Logo />
  </div>
);
